import { useState } from 'react'

import { ASSET_DIR } from '@/constants/agriOutput'

import Picture from '../picture'
import AccordionItem from './AccordionItem'

interface DesktopSourcingRegionlistProps {
  accorditonList: {
    heading: string
    description: string
    icon: string
  }[]
}

const DesktopSourcingRegionlist = ({
  accorditonList,
}: DesktopSourcingRegionlistProps) => {
  const [expandedIndex, setExpandedIndex] = useState(0)

  const onToggle = (index: number) => {
    setExpandedIndex(index)
  }

  return (
    <section className="hidden md:flex">
      <section className="hidden relative md:flex justify-center items-center pt-6 md:w-1/2">
        <Picture
          image={`${ASSET_DIR}/spices-map`}
          imageAlt={'Source region map of spices'}
          imageStyle={`sticky top-0 left-0 transition-opacity duration-500 opacity-100 visible max-h-[83vh]`}
          key={'Source region map of spices'}
        />
      </section>
      <section className="pl-16 md:w-1/2">
        {accorditonList.map(({ heading, description, icon }, index) => (
          <AccordionItem
            key={heading}
            heading={heading}
            icon={icon}
            description={description}
            isExpanded={expandedIndex === index}
            onToggle={() => onToggle(index)}
          />
        ))}
      </section>
    </section>
  )
}

export default DesktopSourcingRegionlist
